import React from "react";
import Layout from "components/Layout";
import Widget from "components/Widget";
import AlternateTherapyTable from "components/Table/List";
import EditSpecialistPage from "./components/EditSpecialistPage";
import TableAction from "components/Table/Actions/ActionDropdown";
import ShowModal from "components/Modal/ShowModal";
import AddSpecialistPage from "./components/AddSpecialistPage";
import { renderArticle } from "utils/commonUseFunction";
const Index = () => {
  const columns = [
    {
      title: "Page",
      render: (record) => (
        <span className="gx-text-capitalize">{record.type}</span>
      ),
      key: "page",
      width: "200px",
    },
    {
      title: "Title",
      render: (record) => <span>{record.title}</span>,
      key: "notification",
      width: "250px",
    },
    {
      title: "Description",
      render: (record) => (
        <span>{renderArticle(record.description, 100, 65)}</span>
      ),
      key: "description",
    },
    {
      title: "",
      render: (record) => <TableAction menu={renderActions(record)} />,
      key: "action",
      width: 50,
    },
  ];

  const renderActions = (record) => {
    return (
      <div className="gx-d-flex gx-flex-column">
        <ShowModal
          record={record}
          modalName={"Edit_SpecialistPage_Modal"}
          buttonName="Edit"
        />
      </div>
    );
  };

  return (
    <Layout>
      <Widget
        styleName="mainTable"
        title="Specialist Page"
        extra={<AddSpecialistPage />}
      >
        <AlternateTherapyTable
          apiName="getAllStaticPage"
          recordName="specialistPageList"
          scroll={true}
          pagination={true}
          columns={columns}
          customQuery={{ portal: "specialist" }}
        />
      </Widget>
      <EditSpecialistPage />
    </Layout>
  );
};
export default Index;
